<template>
  <div class="row">
  	<div class="card col-12 px-1 mb-5" style="width: 18rem;">
	  	<div class="card-body mt-3 mb-5 pt-md-3 px-1">
	  		<div v-bind:class="loading">
		      <div class="d-flex justify-content-center">
		        <div class="spinner-border m-5" role="status">
		          <span class="sr-only">Loading...</span>
		        </div>
		      </div>
		    </div>
		    <div v-bind:class="result">
		  		<div class="row justify-content-center">
		  			<div class="col-12" v-if="!aceptar_instrucciones">
		  				<div class="row px-md-5 justify-content-center">
		  					<div class="col-12 text-center">
		  						<h3>¡Bienvenido!</h3>
		  					</div>
		  					<div class="col-md-10 mt-3 text-center">
		  						Estas a punto de iniciar tu proceso de exámen para el Ingreso de la Facultad de Ciencias Biológicas, pero antes de iniciar es importante que tomes los siguientes puntos:
		  					</div>
		  					<div class="col-md-10 mt-4">
		  						<ul>
		  							<li>
		  								Necesitaras tener disponible 3 horas de tiempo para llevar a cabo todo el proceso, ya que el registro esta cronometrado y en caso de que tardes más del tiempo señalado y se termine el tiempo, el sistema se cerrara, dejando inconcluso tu proceso, pudiendo llegar a afectar esta situación a tu evaluación.
		  							</li>
		  							<li>
		  								Necesitaras tener a la mano tu folio de registro, ya que dicho dato será el necesario para que puedas presentar. Tu contraseña es tu mismo folio de registro.
		  							</li>
		  						</ul>
		  					</div>
		  					<div class="col-md-8 mt-3 text-center">
		  						De faltarte alguno de los puntos antes mencionados, te recomendamos que no inicies tu examen, ya que como se te mencionó, dura 3 horas.
		  					</div>
		  					<div class="col-md-10 mt-3 text-center">
		  						Si tienes alguna duda o problema, puedes comunicarte con el equipo de soporte en nuestro Chat de Ayuda ubicado al inferior de la página.
		  					</div>
		  					<div class="col-md-10 text-center mt-2">
		  						El Chat de Ayuda solo estará disponible en un horario de 9 am a 2 de la tarde.
		  					</div>
							<div class="col-12 mt-3 text-center">
								<button v-on:click="Aceptar_Instrucciones" class="btn btn-success">Iniciar</button>
							</div>
		  				</div>
		  			</div>
					<form
						v-if="aceptar_instrucciones"
						class="col-md-6 col-lg-4 col-10 mt-3 text-center"
						autocomplete="off"
						v-on:submit.prevent="Iniciar_Sesion">
					    <h5 class="card-title">Presentar Exámen</h5>
					    <h6 class="card-subtitle mb-2 text-muted">Iniciar Sesión</h6>
					    <div class="form-group mt-4">
						    <label for="matricula">No. Registro</label>
						    <input
						    	autocomplete="off"
						    	type="text"
						    	v-model="matricula"
						    	class="form-control mx-auto text-center"
						    	id="matricula">
						</div>
						<div class="form-group">
							<label for="sexo">Sexo</label>
							<select
								class="form-control"
								id="sexo"
								v-model="sexo">
							<option class="text-center" value="H">Hombre</option>
							<option class="text-center" value="M">Mujer</option>
							</select>
						</div>
					    <button type="submit" class="btn btn-primary mt-4">Validar</button>
					</form>
		  		</div>
		  	</div>
	  	</div>
	</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      aceptar_instrucciones:false,
      matricula:'',
	  sexo: 'H'
    }
  },
  methods:{
  	Aceptar_Instrucciones(){
  		this.aceptar_instrucciones=true;
  	},
  	Validar(){
  		var pasar = true;
  		if (this.matricula.length==0) {
  			pasar=false;
  			swal("Datos incompletos","El numero de registro es obligatorio", "error");
  		}
  		return pasar;
  	},
  	Iniciar_Sesion(){
  		if (!this.Validar()) {return;}
  		this.Cargando();
		this.$http.post('login',{
			matricula:this.matricula,
			password:this.matricula,
			sexo: this.sexo,
			idconcepto:1
		})
		.then(respuesta=>{return respuesta.json()})
		.then(respuestaJson=>{
			if (respuestaJson.resp=='Excelente') {
				localStorage.apikeySiepsBiologicasUanl=JSON.stringify(respuestaJson.token);
			  	this.$router.push({name:'Examenes'});
			}else{
				this.Listo();
			  	swal("¡Ups!",respuestaJson.resp, "error");
			}
		})
		.catch(error=>{
			this.Listo();
			swal("Favor de Intentar mas tarde", "Problemas para validar la información", "error");
		});
  	},
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	}
  },
  created(){
  	localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");
  }
};
</script>

<style scoped>
#emailHelp{
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue